import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { amIExclusiveSeller } from '../../lib/marketExclusives';

// On the supplier home of a «حصريات معبر» account (owner, 2026-10-29): what
// the account is, where its products show, and the two things it does — add
// products, answer the traders. Renders nothing for every other supplier.

const T = {
  ar: { title: 'حسابك: حصريات معبر', body: 'منتجاتك النشطة تظهر للتجار في صفحة «حصريات معبر» بالمتجر. التاجر يتواصل معك من صفحة المنتج، وتتفاوضون على السعر والكمية والشحن، ثم ترسل له فاتورة بالريال من المحادثة — بدون رسوم.', page: 'صفحة الحصريات', msgs: 'المحادثات', add: 'أضف منتجًا' },
  en: { title: 'Your account: MAABAR Exclusives', body: 'Your active products show to traders on the store\'s «MAABAR Exclusives» page. A trader contacts you from the product page; you agree price, quantity and shipping, then send a SAR invoice from the chat — no fee.', page: 'Exclusives page', msgs: 'Messages', add: 'Add a product' },
  zh: { title: '您的账户：MAABAR 独家', body: '您的上架产品会显示在商城的「MAABAR 独家」页面。买家从产品页联系您，双方商定价格、数量和运费后，您在聊天中发送沙特里亚尔发票——无服务费。', page: '独家页面', msgs: '消息', add: '添加产品' },
};

export default function ExclusiveSellerBanner({ lang = 'ar', onAddProduct }) {
  const nav = useNavigate();
  const t = T[lang] || T.ar;
  const [on, setOn] = useState(false);
  useEffect(() => { let alive = true; amIExclusiveSeller().then((v) => { if (alive) setOn(v); }); return () => { alive = false; }; }, []);
  if (!on) return null;
  const font = lang === 'ar' ? 'var(--font-ar)' : 'var(--font-sans)';
  const btn = { padding: '8px 14px', borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: font };
  return (
    <div data-exclusive-seller-banner="1" style={{ background: '#1A1814', color: '#FAF9F7', borderRadius: 16, padding: '16px 18px', marginBottom: 16, borderInlineStart: '4px solid #9A7636' }}>
      <p style={{ margin: 0, fontSize: 15.5, fontWeight: 700, fontFamily: font }}>{t.title}</p>
      <p style={{ margin: '6px 0 12px', fontSize: 13, lineHeight: 1.7, color: '#E8DFC9', fontFamily: font }}>{t.body}</p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button type="button" onClick={() => nav('/inbox')} style={{ ...btn, border: 'none', background: '#9A7636', color: '#fff' }}>{t.msgs}</button>
        {onAddProduct && <button type="button" onClick={onAddProduct} style={{ ...btn, border: '1px solid rgba(250,249,247,0.4)', background: 'none', color: '#FAF9F7' }}>{t.add}</button>}
        <button type="button" onClick={() => nav('/market/exclusives')} style={{ ...btn, border: '1px solid rgba(250,249,247,0.4)', background: 'none', color: '#FAF9F7' }}>{t.page}</button>
      </div>
    </div>
  );
}
